import { Container } from 'react-bootstrap';

const Service = () => {
    return (
        <Container fluid>
            <h1>Сервис моей техники</h1>
        </Container>
    );
};

export default Service;